import React from 'react'
import DOMPurify from 'dompurify'

export function SanitizeDangerouslySetInnerHtml({ text }) {
  return <span dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(text) }} />
}
